export default "__VITE_ASSET__74365795__"